import React from 'react';
import { connect } from 'react-redux';
import "./AudioTag.css";
import { injectIntl } from 'react-intl'
import { unsetIsAudioTagActive } from '../../../actions/CommentAction'
import {Icon, Tooltip} from "antd";
import AudioIconDart from "../../../assets/icons/audio_dart.svg";


class AudioTag extends React.Component {
    render() {
        const {
            versionNumber,
            unsetIsAudioTagActive,
            audioTime,
            intl
        } = this.props;
        return (
            <React.Fragment>
                <div className='audio-tag-wrapper' >
                    <p>{intl.formatMessage({ id: "tagging_on_page" })} &nbsp; </p>
                    <div className='audio-tag-text-indicator'>
                        <img src={AudioIconDart} alt="audio" className='audio-tag-icon' />
                        <p>{`${audioTime} v.${versionNumber}`}</p>
                    </div>
                    <p>&nbsp;&nbsp;</p>
                    <Tooltip placement='top' title={intl.formatMessage({ id: "delete_pdf_tag" })}>
                        <p className='cursor-pointer' onClick={unsetIsAudioTagActive}><Icon type="close-circle" /></p>
                    </Tooltip>

                </div>
            </React.Fragment>
        )
    }

}

const mapStateToProps = (state, ownProps) => ({
    isAudioTagActive: state.comments.isAudioTagActive,
    audioTime: state.comments.audioTime,
    versionNumber: state.comments.itemSelected.document.versionNumber

})

const mapDispatchToProps = {
    unsetIsAudioTagActive
}

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(AudioTag))
